export default "__VITE_ASSET__0yhD$ZN6__"